import { PermissionGate } from "@components/PermissionGate";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { Button, Group, Modal, Text } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { IconCalendar } from "@tabler/icons-react";

import { handleOnChange } from "@utils/handleOnChange";

import { useCreateSurgicalRecord } from "@hooks/mutations/patient/useCreateSurgicalRecord";

import { PatientSurgicalHistoryItem } from "@customTypes/patient";

import { StyledAddAllergyModalContent } from "../AddAllergyModal/AddAllergyModal.styled";


interface AddSurgicalHistoryModalProps {
  close: () => void;
  opened: boolean;
}

export const AddSurgicalHistoryModal = ({
  opened,
  close,
}: AddSurgicalHistoryModalProps) => {
  const { t } = useTranslation();

  const { patientId } = useParams();
  const [date, setDate] = useState<Date | null>(null);
  const [formData, setFormData] = useState({} as PatientSurgicalHistoryItem);
  const { mutate: createSurgicalRecord, isLoading: isCreateSRLoading } =
    useCreateSurgicalRecord();

  const handleAddSurgicalRecord = () => {
    if (!formData.surgery || !date) return;

    const newFormData = { ...formData, patientId, date: date as Date };
    createSurgicalRecord(newFormData, {
      onSuccess: () => {
        setFormData({} as PatientSurgicalHistoryItem);
        setDate(new Date());
        close();
      },
    });
    // console.log("Adding surgical record");
  };

  return (
    <Modal
      centered
      title={<Text fw={500}>{t("add-surgical-history")}</Text>}
      opened={opened}
      onClose={close}
      styles={{ body: { minHeight: "auto" } }}
      // scrollAreaComponent={ScrollAreaAutosize}
    >
      <StyledAddAllergyModalContent>
        <form className="form">
          <div className="form-field">
            <label htmlFor="name">{t("surgery-name")}</label>
            <input
              type="text"
              id="name"
              name="surgery"
              onChange={e => handleOnChange(e, setFormData, formData)}
            />
          </div>

          <div className="form-field">
            <DatePickerInput
              label={t("surgery-date")}
              value={date}
              onChange={setDate}
              leftSection={<IconCalendar size={16} stroke={1.5} />}
            />
          </div>
        </form>

        <Group mt="xl" justify="end">
          <PermissionGate permission="consultations.create"><Button
            onClick={handleAddSurgicalRecord}
            disabled={!formData.surgery || !date}
            loading={isCreateSRLoading}>
            {t("add-record")}
          </Button></PermissionGate>
        </Group>
      </StyledAddAllergyModalContent>
    </Modal>
  );
};
